import { yup } from '@medely/ui-kit';

type EducationFormValidationSchemaProps = yup.InferType<typeof educationFormSchema>;

export type EducationFormValidationSchemaFieldNames = keyof EducationFormValidationSchemaProps;

export const educationFormSchema = yup.object().shape({
  school_name: yup.string().required('Required'),
  city: yup.string().required('Required'),
  state_id: yup.number().required('Required'),
  degree_type: yup.string().required('Required'),
  field_of_study: yup.string().required('Required'),
  end_date: yup.string().required('Required'),
});
